<template>
  <div class="con-wrap">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content vehicle-pie">
          <p class="baseTitle">车辆统计</p>
          <base-pie
            v-if="flag"
            :chartData="vehicleData"
            :chartTotal="vehicleTotal"
            :chartName="vehicleName"
            :color="color"
            :legend="vehicleLegend"
          ></base-pie>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content device-pie">
          <p class="baseTitle">设备统计</p>
          <base-pie
            v-if="flag"
            :chartData="deviceData"
            :chartTotal="deviceTotal"
            :chartName="deviceName"
            :color="color"
            :legend="deviceLegend"
          ></base-pie>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content app-pie">
          <p class="baseTitle">app统计</p>
          <base-pie
            v-if="flag"
            :chartData="appData"
            :chartTotal="appTotal"
            :chartName="appName"
            :color="color"
            :legend="appLegend"
          ></base-pie>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BasePie from "./components/BasePie.vue"
export default {
  components: {
    BasePie,
  },
  data() {
    return {
      vehicleData: [],
      vehicleLegend: ["在线车辆", "发电中车辆", "离线车辆"],
      color: ["#02d34c", "#ccc", "#ff9000"],
      vehicleTotal: 0,
      vehicleName: "车辆总数",
      deviceData: [],
      deviceLegend: ["在线设备", "离线设备"],
      deviceColor: [],
      deviceTotal: 0,
      deviceName: "设备总数",
      appData: [],
      appLegend: ["在线用户", "离线用户"],
      appColor: [],
      appTotal: 0,
      appName: "用户总数",
      flag: true,
    }
  },
  created() {
    let judge = this.hasPerm("statistics:data:base")
    if (judge) {
      this.getChartData()
    }
  },
  methods: {
    async getChartData() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/statistics/data/base")
      if (res.code == 1) {
        _this.vehicleData = res.data.vehicles
        _this.vehicleTotal = parseInt(res.data.vehicleTotal)
        _this.deviceData = res.data.devices
        _this.deviceTotal = res.data.deviceTotal
        _this.appData = res.data.users
        _this.appTotal = res.data.userTotal
        console.log(_this.vehicleTotal)
      } else {
        _this.$message.warning(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 20px;
  background: #fff;
}
.vehicle-pie {
  width: 100%;
  height: 100%;
}
.baseTitle {
  width: 100%;
  height: 36px;
  line-height: 36px;
  padding-left: 10px;
  margin-bottom: 20px;
  border-left: 6px solid #0093ff;
  font-size: 22px;
  font-weight: bold;
  color: #333;
}
</style>
